import { Controller } from "@hotwired/stimulus"

// Polls Dev Debug PO compare status until the Sidekiq job finishes, then reloads.
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 3000 },
    running: Boolean
  }

  connect() {
    this.timeoutId = null
    if (this.runningValue && this.hasUrlValue) {
      this.schedulePoll(500)
    }
  }

  disconnect() {
    this.clearPoll()
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      })

      if (!response.ok) throw new Error(`PO compare status failed: ${response.status}`)

      const status = await response.json()
      this.applyStatus(status)

      if (status.terminal) {
        window.location.reload()
        return
      }
    } catch (_error) {
      // Keep polling through transient blips.
    }

    this.schedulePoll()
  }

  applyStatus(status) {
    const message = status.progress_message || "Running…"
    this.element.querySelectorAll("[data-po-compare-progress-message]").forEach((el) => {
      el.textContent = message
    })

    const fetched = status.progress_fetched || 0
    const total = status.progress_total || 0
    const counts = total > 0 ? `${fetched} / ${total}` : "—"
    this.element.querySelectorAll("[data-po-compare-progress-counts]").forEach((el) => {
      el.textContent = counts
    })

    this.element.querySelectorAll("[data-po-compare-api-calls]").forEach((el) => {
      el.textContent = String(status.api_calls || 0)
    })
  }

  schedulePoll(delay = this.intervalValue) {
    this.clearPoll()
    this.timeoutId = window.setTimeout(() => this.poll(), delay)
  }

  clearPoll() {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }
}
